import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=1bd79c00&"
import script from "./Select.vue?vue&type=script&lang=js&"
export * from "./Select.vue?vue&type=script&lang=js&"
import style0 from "./Select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd79c00')) {
      api.createRecord('1bd79c00', component.options)
    } else {
      api.reload('1bd79c00', component.options)
    }
    module.hot.accept("./Select.vue?vue&type=template&id=1bd79c00&", function () {
      api.rerender('1bd79c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/Select.vue"
export default component.exports